import {
  LAYOUT,
  SLIDE_LAYOUT_PROFILES,
} from "./welcomeScreenConstants";

export const resolveSlideLayout = (slide) => {
  const profile =
    SLIDE_LAYOUT_PROFILES[slide.layoutProfile] ||
    SLIDE_LAYOUT_PROFILES.featureBar;

  return {
    heroMinHeight: slide.heroHeight || profile.heroMinHeight || LAYOUT.heroMinHeight,
    heroMaxHeight: profile.heroMaxHeight ?? null,
    heroFlexGrow: profile.heroFlexGrow ?? false,
    bodyScrollable: profile.bodyScrollable ?? false,
  };
};
